import { Typography } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import { MeasurementData, WeatherAlertCurrentConditions } from './types';
import {
  convertNumberFromDB,
  getUnitForMeasurementType,
} from './utils/dataConverters';

interface Props {
  weatherAlerts: WeatherAlertCurrentConditions;
  condition: MeasurementData;
}

const WeatherAlert = ({ weatherAlerts, condition }: Props) => {
  const inImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  return (
    <>
      {weatherAlerts[condition].map(
        (weatherAlert, idx) =>
          weatherAlert.threshold && (
            <Typography
              color={weatherAlert.warning ? 'red' : 'orange'}
              variant='body2'
              key={idx}
            >
              {weatherAlert.dishName +
                ' > ' +
                convertNumberFromDB(weatherAlert.threshold, condition)?.toFixed(
                  2
                ) +
                ' ' +
                getUnitForMeasurementType(condition, inImperial)}
            </Typography>
          )
      )}
    </>
  );
};

export default WeatherAlert;
